module.exports = __webpack_public_path__ + "static/react-dde201a7531c3357e9032ddf52da7522.png";